/* eslint-disable indent */
import { Modal, Rate, Table, Card, Tooltip } from "antd";
import { Fragment } from "react";

import AnalyticsGenericBarGraph from "../../common-utils/GenericBarGraph";
import AnalyticsGenericPieGraph from "../../common-utils/GenericPieGraph";

const ViewResponseModal = ({
  aggregatedSurveyResponses = {},
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Free-text answers can run to thousands of characters, so the column is
  // truncated to one line and the full text moved into a tooltip.
  const textResponseTableColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index",
      width: 70
    },
    {
      title: "Response",
      dataIndex: "response",
      key: "response",
      ellipsis: { showTitle: false },
      render: (response) => (
        <Tooltip placement="topLeft" title={response}>
          {response}
        </Tooltip>
      )
    }
  ];

  return (
    <Modal
      title="Survey Response"
      open={isModalOpen}
      onCancel={handleCancel}
      onOk={handleOk}
      width={1200}
    >
      {(Object.keys(aggregatedSurveyResponses) || []).map((questionId) => {
        const { title, type, aggregatedResponses } = aggregatedSurveyResponses[questionId];
        return (
          <Fragment key={questionId}>
            {type === "RATING" && (
              <Card>
                <div>
                  <h3>{title}</h3>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    Average Rating: {Number(aggregatedResponses || 0).toFixed(2)}
                    <Rate disabled allowHalf value={aggregatedResponses} />
                  </div>
                </div>
              </Card>
            )}
            {type === "MULTIPLE_CHOICE_SINGLE_SELECT" && (
              <Card>
                <div>
                  <h3>{title}</h3>
                  <AnalyticsGenericBarGraph
                    dataPoints={aggregatedResponses}
                    xAxisFieldName="response"
                    yAxisFieldName="count"
                  />
                </div>
              </Card>
            )}
            {type === "MULTIPLE_CHOICE_MULTI_SELECT" && (
              <Card>
                <div>
                  <h3>{title}</h3>
                  <AnalyticsGenericBarGraph
                    dataPoints={aggregatedResponses}
                    xAxisFieldName="response"
                    yAxisFieldName="count"
                  />
                </div>
              </Card>
            )}
            {type === "CHECKBOX" && (
              <Card>
                <div>
                  <h3>{title}</h3>
                  <AnalyticsGenericPieGraph
                    data={aggregatedResponses}
                    angleField={"count"}
                    colorField={"response"}
                  />
                </div>
              </Card>
            )}
            {type === "TEXT" && (
              <Card>
                <h3>{title}</h3>
                <Table
                  columns={textResponseTableColumns}
                  dataSource={aggregatedResponses || []}
                  pagination={{ pageSize: 10, hideOnSinglePage: true, size: "small" }}
                  bordered
                  size="small"
                  tableLayout="fixed"
                />
              </Card>
            )}
          </Fragment>
        );
      })}
    </Modal>
  );
};

export default ViewResponseModal;
